import React, { useState } from 'react'
import {
  Row,
  NotificationIcon,
  WarningIcon,
  LoadingSpinner,
} from '@paypalcorp/pp-react'
import NotificationCard from './notificationCard'
import { useApplicationContext } from '../../../context/ApplicationContext'
import SellerInvitationDialog from '../../../components/seller-invitations-modal/index'

// import EmailConfirmationAlert from '../../../components/seller-invitations-modal/sections/email-confirmation-alert'
import UpgradeAccountAlert from '../../../components/seller-invitations-modal/sections/upgrade-account-alert'
/* eslint-disable-next-line import/no-nodejs-modules */
import { Buffer } from 'buffer'
import { getUserType } from '../../../utils/user-utils'
import { ACCOUNT_TYPE } from '../../../common/constant'
import { recordDynamicEvent } from '../../../components/common/analytics/utils'

function SellerInvitation({
  approvalRequestInfo,
  hasApprovalRequest,
  hasUpgrade,
}) {
  const {
    isConfirmedEmail,
    user,
    emailRedirectionPersonal,
    emailRedirectionBusiness,
    encryptedEmailConfirmtId,
    setReloadPage,
    setApprovalRequestInfo,
    setHasApprovalRequest,
    logger,
    sellerInvitationLoaded,
  } = useApplicationContext()

  let flowUrl = {
    returnUrl: '/developer/dashboard',
    cancelUrl: '/developer/dashboard',
  }
  let jsonFlowUrl = '',
    encodedFlowUrl = '',
    emailURL = ''
  try {
    jsonFlowUrl = JSON.stringify(flowUrl)
    encodedFlowUrl = Buffer.from(jsonFlowUrl).toString('base64')
  } catch (error) {
    logger.error('Error parsing JSON flowUrl:' + error)
    jsonFlowUrl = ''
    encodedFlowUrl = ''
  }
  const accountType = getUserType(user)
  if ([ACCOUNT_TYPE.PERSONAL].includes(accountType)) {
    logger.info(
      `Redirecting PERSONAL account to Email Confirmation. Parameters: id=${encryptedEmailConfirmtId}, flow=${encodedFlowUrl}`,
    )

    emailURL = `${emailRedirectionPersonal}?id=${encryptedEmailConfirmtId}&flow=${encodedFlowUrl}&source=devdashnodeweb&fetchById=true`
  } else if (
    [ACCOUNT_TYPE.BUSINESS, ACCOUNT_TYPE.PREMIER].includes(accountType)
  ) {
    emailURL = emailRedirectionBusiness
  }
  logger.info(
    `seller-invitation Redirecting ${accountType} account to Email Confirmation: ${emailURL}`,
  )
  const noOfInvitations = approvalRequestInfo.length

  const [isInvitationSheetOpen, setIsInvitationSheetOpen] = useState(false)
  const [sheetContent, setSheetContent] = useState('initial')
  const [isUpgradeAlert, setIsUpgradeAlert] = useState(false)
  const [inviteId, setInviteId] = useState()

  const getUpdatedSellerInvitation = (id) => {
    let newState = [...approvalRequestInfo]
    newState = newState.filter((item) => item.id !== id)
    if (newState?.length > 0) {
      setApprovalRequestInfo(newState)
      setHasApprovalRequest(true)
    } else {
      setHasApprovalRequest(false)
    }
  }

  const closeInvitationSheet = () => {
    // setReloadPage('yes')
    setIsInvitationSheetOpen(false)
    getUpdatedSellerInvitation(inviteId)
  }

  const handlerSheetContent = () => {
    setSheetContent('initial')
  }

  const openInvitationSheet = () => {
    recordDynamicEvent(`dashboard_invitation,click,dashboard_invitation_modal`)
    setIsInvitationSheetOpen(true)
    setSheetContent('initial')
  }

  const OpenUpgradeSheet = () => {
    setIsUpgradeAlert(true)
  }

  const showReviewContent = () => {
    if (hasUpgrade) {
      setSheetContent('upgradeRequired')
    } else {
      setSheetContent('review')
    }
  }

  const redirectURL = () => {
    window.open(emailURL)
  }

  const pendingInvites = (
    <>
      <Row>
        {sellerInvitationLoaded ? (
          <LoadingSpinner
            screenReaderText="loading"
            style={{ right: '-50%' }}
          />
        ) : null}

        {hasUpgrade ? (
          <>
            <NotificationCard
              icons={<WarningIcon size="sm" color="sysColorErrorMain" />}
              title="Upgrade now"
              bodyText="Upgrade your account to accept invites and live mode"
              handlerClick={OpenUpgradeSheet}
            />
          </>
        ) : null}
        <UpgradeAccountAlert
          isUpgradeAlert={isUpgradeAlert}
          closeModal={() => setIsUpgradeAlert(false)}
        />
        {!isConfirmedEmail && accountType === 'PERSONAL' && !hasUpgrade ? (
          <>
            <NotificationCard
              icons={<WarningIcon size="sm" color="sysColorErrorMain" />}
              title="Confirm your email"
              bodyText={`This will let you get back to using your account normally.`}
              handlerClick={redirectURL}
            />
          </>
        ) : null}
        {hasApprovalRequest ? (
          <>
            <SellerInvitationDialog
              closeInvitationSheet={closeInvitationSheet}
              isInvitationSheetOpen={isInvitationSheetOpen}
              sheetContent={sheetContent}
              showReviewContentHandler={showReviewContent}
              approvalRequestInfo={approvalRequestInfo}
              confirmEmailURL={emailURL}
              setReloadPage={setReloadPage}
              handlerSheetContent={handlerSheetContent}
              getUpdatedSellerInvitation={getUpdatedSellerInvitation}
              setInviteId={setInviteId}
            />
            <NotificationCard
              icons={<NotificationIcon size="sm" color="sysColorLinkMain" />}
              title="View pending invitations"
              bodyText={`You have ${noOfInvitations} pending invitations to accept.`}
              handlerClick={openInvitationSheet}
            />
          </>
        ) : null}
      </Row>
    </>
  )
  return <>{pendingInvites}</>
}

export default SellerInvitation
